module.exports = __webpack_public_path__ + "img/participant-list-desktop-fr.2ff5b8cf.jpg";